export default "__VITE_ASSET__BVg3A2Z0__"